import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import AITools from "../pages/ai-tools/page";
import AIMakeMoney from "../pages/ai-money/page";
import About from "../pages/profile/page";
import Portfolio from "../pages/portfolio/page";
import OurWorkDemo from "../pages/our-work-demo/page";
import DemoViewer from "../pages/demo-viewer/page";
import LearningHub from "../pages/learning-hub/page";
import Bienvenu from "../pages/bienvenu-masengesho/page";

// Auth
import LoginPage from "../pages/auth/LoginPage";
import RegisterPage from "../pages/auth/RegisterPage";
import ProfilePage from "../pages/auth/ProfilePage";
import ProtectedRoute from "../components/auth/ProtectedRoute";

// Academy
import CatalogPage from "../pages/academy/CatalogPage";
import CourseDetailPage from "../pages/academy/CourseDetailPage";
import LearnPage from "../pages/academy/LearnPage";
import CertificateVerificationPage from "../pages/academy/CertificateVerificationPage";
import StudentDashboardPage from "../pages/academy/StudentDashboardPage";

// Client Portal
import ClientPortalPage from "../pages/portal/ClientPortalPage";
import RequestServicePage from "../pages/portal/RequestServicePage";

// Admin
import AdminDashboardPage from "../pages/admin/AdminDashboardPage";
import PaymentInstructionsPage from "../pages/admin/PaymentInstructionsPage";
import PaymentVerificationPage from "../pages/admin/PaymentVerificationPage";

const routes: RouteObject[] = [
  // ── Public site ──────────────────────────────────────────────────────────
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/ai-tools",
    element: <AITools />,
  },
  {
    path: "/ai-money",
    element: <AIMakeMoney />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/our-work-demo",
    element: <OurWorkDemo />,
  },
  {
    path: "/demo-viewer",
    element: <DemoViewer />,
  },
  {
    path: "/learning-hub",
    element: <LearningHub />,
  },
  {
    path: "/bienvenu-masengesho",
    element: <Bienvenu />,
  },

  // ── Auth ─────────────────────────────────────────────────────────────────
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },

  // ── Academy ──────────────────────────────────────────────────────────────
  {
    path: "/academy",
    element: <CatalogPage />,
  },
  {
    path: "/academy/courses/:slug",
    element: <CourseDetailPage />,
  },
  {
    path: "/academy/learn/:slug",
    element: (
      <ProtectedRoute>
        <LearnPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/academy/dashboard",
    element: (
      <ProtectedRoute>
        <StudentDashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/verify-certificate/:code",
    element: <CertificateVerificationPage />,
  },

  // ── Client Portal ─────────────────────────────────────────────────────────
  {
    path: "/portal",
    element: (
      <ProtectedRoute>
        <ClientPortalPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/portal/request-service",
    element: (
      <ProtectedRoute>
        <RequestServicePage />
      </ProtectedRoute>
    ),
  },

  // ── Admin ─────────────────────────────────────────────────────────────────
  {
    path: "/admin",
    element: (
      <ProtectedRoute requireStaff={true}>
        <AdminDashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/payment-instructions",
    element: (
      <ProtectedRoute requireStaff={true}>
        <PaymentInstructionsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/payments",
    element: (
      <ProtectedRoute requireStaff={true}>
        <PaymentVerificationPage />
      </ProtectedRoute>
    ),
  },

  // ── Catch-all ─────────────────────────────────────────────────────────────
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
